import React, { Component } from 'react'
import PropTypes from 'prop-types'
import s from './TripAdvisor.css'

import CircularProgress from '@material-ui/core/CircularProgress'
import ConfigFunctions from './ConfigFunctions'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import { addCssUrlToHead } from '../../utils/DocumentHelper'
import Leaflet, { PROVIDERS } from '../Leaflet/Leaflet'
import GlobalVars, { KEYS } from '../../utils/GlobalVars'
import MapIcon from '@material-ui/icons/Map'
import ListIcon from '@material-ui/icons/List'
import PoiDetailComponent from './PoiDetailComponent'
import PoiListComponent from './PoiListComponent'
import SearchComponent from './SearchComponent'
import SettingsComponent from './SettingsComponent'
import SwipeableViews from 'react-swipeable-views'
// import { Toolbar, ToolbarGroup } from '@material-ui/core/Toolbar'
import Toolbar from '@material-ui/core/Toolbar'
import PoiCache from '../../data/PoiCache'
import {
  CENTER_EUROPE,
} from '../../data/tripadvisor.js'

import I18N from '../../utils/I18nMessageProvider'

import { parse } from 'qs'
import Config from '../../data/Config'
import PoiBubbleComponent from './PoiBubbleComponent'
import SettingsState from '../../data/SettingsState'
import Walkthrough from '../Walkthrough/Walkthrough'
import { isiOS } from '../../utils/DeviceInfoHelper'

const SWIPE_INDEX_MAP = 0
const SWIPE_INDEX_DETAIL = 1

// const MAX_NUMBER_OF_VISIBLE_POIS = 10

const NO_POIS_NEEDED = 'noPois'
const NO_TOOLBAR = 'noToolbar'

export const UNFOCUS_ELEMENT_ID = 'unfocusElement'

const style = {
  list: {
    position: 'absolute',
    top: 0,
    backgroundColor: 'white',
    margin: '64px 10px 0 10px'
  }
}

class TripAdvisor extends Component {

  static parseLocationString (locationString) {
    if (locationString && locationString.startsWith('@')) {
      const components = locationString.substring(1).split(',')
      const lat = Number(components[0])
      const lng = Number(components[1])
      if ((lng || lng === 0) && (lat || lat === 0)) {
        return {
          lat,
          lng,
        }
      }
    }
    return null
  }

  constructor (props) {
    super(props)

    I18N.set(props.i18n)
    if (props.lang) {
      GlobalVars.set(KEYS.LOCALE, props.lang.replace('_', '-'))
    }

    this.config = new Config(props.config)
    GlobalVars.set(KEYS.CONFIG, this.config)

    /**
     *
     * @type {LeafletControlInterface}
     */
    this.leafletController = null

    this.updatePoisDeferredTimeout = null
    this.searchForCoordsTimeout = null

    this.poiCache = new PoiCache()
    this.lastCoordSearchTimeoutId = null

    this.isOpeningMarker = null
    this.isOpeningOrClosingList = false

    this.denySearchByMapChange = false

    this.leafletDataSource = null // will be set on mounting
    this.leafletDataSourceOverlay = this.getLeafletDataSourceOverlay(props.config.sources)

    this.filterSettings = null

    this.searchIconTimeout = null

    this.state = {
      currentPoi: null,
      mapSize: {width: 100, height: 100},
      mapCenter: props.mapCenter,
      swipePageIndex: SWIPE_INDEX_MAP,
      visiblePois: [],
      showErrorAlert: false,
      errorAlertMessage: '',
      userPosition: null,
      filterSettings: {visibility: {}},
      showSettings: false,
      visibleMapArea: null,
      mapHeight: null,
      settingState: new SettingsState(),
      showOverlay: false,
      overlayShown: false,
      userPosSet: false,
      poisSet: false,
      showSettingsWithId: '',
      selectedCountry: null,
      needsCountryForRequest: props.config.needsCountryForRequests,
      showIsSearchingOverlay: false,
      userPositionLatLng: null,
      locationMarkerPosition: null
    }

    this.configFunctions = new ConfigFunctions(
      this.state,
      () => this.state,
      this._setState,
      this.updatePois,
      this.getShowMapMethod,
      this.state.settingState
    )

    this.kesiGoBackFunc = null

    this.availableCategories = Object.keys(props.config.categories)

  }

  componentWillReceiveProps (nextProps) {
    this.availableCategories = Object.keys(nextProps.config.categories)
    if (nextProps.lang && nextProps.lang !== this.props.lang) {
      GlobalVars.set(KEYS.LOCALE, nextProps.lang.replace('_', '-'))
    }
  }

  componentWillMount () {
    const kesiOS = window.KesiTools ? window.KesiTools.getOS() : null
    if (isiOS() || kesiOS === 'ios') {
      document.body.classList.add(s.iosNoScrolling)
    }

    this.leafletDataSource = this.getLeafletDataSource(this.props.config.sources)
    this.loadConfigCss()

    let categoryConfig = this.config.getCategoriesConfig()

    const visibilities = {}
    Object.keys(categoryConfig).forEach(category => {
      visibilities[category] = categoryConfig[category].hasOwnProperty('activatedDefault') ? categoryConfig[category].activatedDefault : true
    })

    this.setState({filterSettings: {visibility: visibilities}})

  }

  componentDidMount () {

    this.setState({
      mapHeight: window.innerHeight,
    })
    this.configFunctions.deployFunctionsToWindow()

    const onMounted = () => {
      if (window.KesiTools) {
        window.KesiTools.notifyAlive()
        this.registerKesiBackListener()
      }

      if (this.config.getOverlayConfig() !== null) {
        setTimeout(() => {
          this.setState({showOverlay: true})
        })
      }

      const args = parse(window.location.search)
      if (args.location) {
        const location = TripAdvisor.parseLocationString(args.location)
        if (location) {
          this.setState({
            userPositionLatLng: location,
            showList: false,
            locationMarkerPosition: location
          })

          const config = this.config.getConfig()
          if (config.type && config.type === NO_POIS_NEEDED) {
            this.searchForUrlPosition(false, 7)
          }
          else {
            this.searchForCoords(location, null, null, true, true, true)
          }

          return
        }
      }
      this.searchForUserPosition(true)
    }

    const checkIfMounted = () => {
      if (!this.state.mapHeight) {
        setTimeout(() => {
          checkIfMounted()
        }, 200)
        return
      }
      onMounted()
    }

    window.setTimeout(() => {
      checkIfMounted()
    }, 200)
  }

  componentWillUnmount () {
    this.unregisterKesiBackListener()
    super.componentWillUnmount()
  }

  getLeafletDataSource (sources) {
    if (!sources || sources.length === 0) {
      return ''
    }

    let textSources = []
    if (sources.includes('TRIPADVISOR')) {
      if (window.KesiTools) {
        textSources.push('&copy; <a onclick="window.KesiTools.openWebsiteInSystemBrowser(\'https://tripadvisor.com\')">TripAdvisor</a>')
      }
      else {
        textSources.push('&copy; <a href="https://tripadvisor.com">TripAdvisor</a>')
      }
    }
    if (sources.includes('EUROCENTER')) {
      if (window.KesiTools) {
        textSources.push('&copy; <a onclick="window.KesiTools.openWebsiteInSystemBrowser(\'https://euro-center.com\')">Eurocenter</a>')
      }
      else {
        textSources.push('&copy; <a href="https://euro-center.com">Eurocenter</a>')
      }
    }
    if (sources.includes('GWS')) {
      if (window.KesiTools) {
        textSources.push('&copy; <a onclick="window.KesiTools.openWebsiteInSystemBrowser(\'https://globalwarningsystem.com\')">GWS</a>')
      }
      else {
        textSources.push('&copy; <a href="https://globalwarningsystem.com">GWS</a>')
      }
    }
    if (sources.includes('HERE')) {
      if (window.KesiTools) {
        textSources.push('&copy; <a onclick="window.KesiTools.openWebsiteInSystemBrowser(\'https://developer.here.com\')">HERE</a>')
      }
      else {
        textSources.push('&copy; <a href="https://developer.here.com">HERE</a>')
      }
    }
    const year = new Date().getFullYear()

    return `Data ${year} ` + textSources.join(', ')
  }

  getLeafletDataSourceOverlay (sources) {
    if (sources && sources.includes('TRIPADVISOR')) {
      return (
        <div className={s.tripAdvisorOverlay}>
          Powered by
          <img alt='TripAdvisor' src={require('./img/tripAdvisor.png')}/>
        </div>
      )
    }

    return null
  }

  registerKesiBackListener () {
    if (window.KesiTools) {
      window.KesiTools.addOnBackListener(this.onKesiBack)
    }
  }

  unregisterKesiBackListener () {
    if (window.KesiTools) {
      window.KesiTools.removeOnBackListener(this.onKesiBack)
    }
  }

  onKesiBack = (aliveCallback) => {
    if (this.kesiGoBackFunc) {
      this.kesiGoBackFunc()
      aliveCallback(true)
    }
    else {
      aliveCallback(false)
    }
  }

  _setState = (state) => {
    this.setState(state)
  }

  getOnMapBoundsChangedMethod () {

    // console.log('getOnMapBoundsChangedMethod')

    return (mapValues) => {
      const onDone = (mapValues2) => {
        this.setState({
          mapSize: mapValues2.size,
          mapCenter: mapValues2.center,
          visibleMapArea: mapValues2.marginBounds,
          // currentPoi: null
        })

        if (this.denySearchByMapChange) {
          this.denySearchByMapChange = false
          return
        }
        this.searchForCoordsDeferred(mapValues.center)
      }

      // on old Android 4 devices the height is not set correctly
      // so set this value manually here
      const mapValues2 = mapValues
      if (mapValues2.size.height === 0) {
        setTimeout(() => {
          mapValues2.size.height = this.state.mapHeight
          onDone(mapValues2)
        }, 200)
        return
      }
      onDone(mapValues)
    }
  }

  getOnMapDragMethod () {
    return () => {
      // clear last search
      if (window && this.lastCoordSearchTimeoutId) {
        window.clearTimeout(this.lastCoordSearchTimeoutId)
      }
    }
  }

  getShowErrorMethod () {
    return (errorMessage) => {
      this.showError(errorMessage)
    }
  }

  loadConfigCss () {
    const cssFile = this.config.getCssUrl()
    if (cssFile) {
      addCssUrlToHead({url: cssFile}, 'GLOBAL_CONFIG_CSS')
    }
  }

  /**
   *
   * @param errorMessage
   * @param repetitiveMessage The same message will not be shown multiple times in a row if this value is set to false.
   */
  showError (errorMessage, repetitiveMessage = true) {
    if (!repetitiveMessage && this.state.errorAlertMessage === errorMessage) {
      return
    }
    this.setState({
      showErrorAlert: true,
      errorAlertMessage: errorMessage,
    })
  }

  /**
   *
   * @param showList  - true for list, false for map, null for no change
   * @returns {function()}
   */
  getShowMapMethod = (showList = null) => {
    const state = {
      swipePageIndex: SWIPE_INDEX_MAP,
    }
    if (showList !== null) {
      state.showList = showList
      this.kesiGoBackFunc = this.getSetShowPoiListMethod(false)
    }
    else {
      this.kesiGoBackFunc = null
    }
    this.setState(state)
  }

  /**
   * @param value {boolean}
   * @returns {function()}
   */
  getSetShowSettingsMethod (value) {
    return () => {
      this.setState({
        showSettings: value,
      })
    }
  }

  getPositionAtAndSearchForCoordsMethod () {
    return (position, radius) => {
      this.leafletController.positionMapAtLocation(position)
      this.poiCache.clearCache()
      this.updatePois(true)
      // this.centerAndZoomMapAroundCenter(position, 0, true);
      this.searchForCoords(position, radius, null, true, true)
    }
  }

  getSearchForUserPositionMethod () {
    return () => {
      this.searchForUserPosition(false)
    }
  }

  getShowPoiDetailMethod () {
    return (poi) => {
      if (typeof poi === 'string') {
        poi = this.poiCache.getPoi(poi)
      }
      this.setState({
        currentPoi: poi,
        swipePageIndex: SWIPE_INDEX_DETAIL,
      })
      this.kesiGoBackFunc = this.getShowMapMethod
      setTimeout(() => {
        this.leafletController.showPopup(poi)
      })
    }
  }

  /**
   *
   * @param showList {boolean}
   * @returns {function()}
   */
  getSetShowPoiListMethod (showList) {

    return () => {
      const timeToWait = showList ? 0 : 50

      setTimeout(() => {
        if (this.isOpeningOrClosingList) {
          return
        }
        this.isOpeningOrClosingList = true
        this.setState({
          showList: showList,
        })

        this.kesiGoBackFunc = showList ? this.getSetShowPoiListMethod(false) : null

        setTimeout(() => {
          this.isOpeningOrClosingList = false
          const promises = this.state.visiblePois.map(poi => {
            return this.poiCache.requestPoiExtraData(poi, this.props.lang)
          })
          Promise.all(promises).then(() => {
            this.updatePois()
          })
        }, 300)

      }, timeToWait)
    }
  }

  requestPoiExtraData = (poi) => {
    return new Promise((resolve, reject) => {
      try {
        if (poi.extraData) {
          resolve(poi)
        }
        this.poiCache.requestPoiExtraData(poi, this.props.lang).then((poi) => {
          this.updatePoisDeferred()
          resolve(poi)
        })
      }
      catch (error) {
        reject(error)
      }
    })
  }

  searchForCoordsAndCountries (coords, countries = []) {
    return this.searchForCoords(coords, 10, null, true, true, false, countries)
  }

  /**
   * @param coords {{lng: number, lat: number}}
   * @param radius {number} defaults to 10
   * @param categories {Array} categories to fetch
   * @param centerAroundPois {boolean} If set to true, the map will make all POIs retrieved with this commit be visible
   * @param centerAroundUser {boolean} If set to true, the map will make the user position to be visible.
   * @param country
   */
  searchForCoords (coords, radius, categories, centerAroundCoords = true, centerAroundPois = false, centerAroundUser = false, country = this.state.selectedCountry) {

    if (window == null) {
      return
    }

    // clear last search
    if (this.lastCoordSearchTimeoutId) {
      window.clearTimeout(this.lastCoordSearchTimeoutId)
    }

    // start new timeout before requesting
    this.lastCoordSearchTimeoutId = window.setTimeout(() => {

      this.setState({
        showIsSearchingOverlay: true
      })

      this.searchIconTimeout = setTimeout(() => {
        this.setState({
          showIsSearchingOverlay: false
        })
      }, 15000)

      const categoriesToRequest = categories || this.availableCategories.filter(category => this.state.filterSettings.visibility[category])

      // console.log('categoriesToRequest', categoriesToRequest)
      if (categoriesToRequest.length === 0) {
        return
      }

      if (this.state.needsCountryForRequest && country === null) {
        return
      }

      this.poiCache.requestCoords(coords, this.state.needsCountryForRequest ? 1000 : radius, !centerAroundPois, this.props.lang, categoriesToRequest, this.state.needsCountryForRequest ? [country] : null).then(
        (taData) => {

          if (!this.state.poisSet) {
            this.setState({poisSet: true})
          }

          clearTimeout(this.searchIconTimeout)

          this.setState({
            showIsSearchingOverlay: false
          })

          let zoomChanged = centerAroundPois
          if (centerAroundPois /*|| centerAroundUser*/) {
            if (taData.getPois().length > 0) {
              // if (centerAroundPois) {
              const poisAndUser = taData.getPois()

              // this.state.userPosition always null -> wont center map, even this.state.userPositionLatLng not working because it is not a poi (and leaflet tries to handle it that way)
              // if (centerAroundUser) {
              //   poisAndUser.push({lat: this.state.userPosition.lat, lng: this.state.userPosition.lng})
              // }
              if (this.leafletController) {
                this.leafletController.centerAroundPois(poisAndUser)
              }
              // }
              // if (!centerAroundUser) {
              //   this.denySearchByMapChange = true
              // }
              // zoomChanged = this.centerAndZoomMapAroundPois(taData, centerAroundUser ? this.state.userPositionLatLng : null).zoomChanged
            }
            else {
              let newRadius = 50
              if (radius < 3) {
                newRadius = 5
              }
              else if (radius < 8) {
                newRadius = 10
              }
              this.searchForCoords(coords, newRadius, null, true, centerAroundPois, centerAroundUser)
            }
          }
          this.updatePois(zoomChanged, centerAroundPois)
          if (this.state.showList) {
            setTimeout(() => {
              const promises = this.state.visiblePois.map(poi => {
                return this.poiCache.requestPoiExtraData(poi, this.props.lang)
              })
              Promise.all(promises).then(() => {
                this.updatePois()
              })
            }, 300)
          }
        },
        (error) => {
          // console.log('got error:', error)
          this.setState({
            showIsSearchingOverlay: false
          })
          if (error && error.userMessageId) {
            this.showError(I18N.get(error.userMessageId), false)
          }
        }
      )
    }, 100)

  }

  searchForCoordsDeferred (coords, radius, categories = null, centerAroundPois = false, centerAroundUser = false) {
    clearTimeout(this.searchForCoordsTimeout)

    this.searchForCoordsTimeout = setTimeout(() => {
      this.searchForCoords(coords, radius, categories, true, centerAroundPois, centerAroundUser)
    }, 800)
  }

  searchForUrlPosition = async (isInitialCall = false, zoomLevel = 10) => {
    await this.waitForLeafletController()
    try {
      // console.log('userPositionLatLng', this.state.userPositionLatLng)
      await this.leafletController.positionMapAtLocation(this.state.userPositionLatLng, zoomLevel)
      this.setState({userPosSet: true})
    }
    catch (error) {
      if (!isInitialCall) {
        this.setState({
          showErrorAlert: true,
          errorAlertMessage: error.message,
        })
      }
    }
  }

  searchForUserPosition = async (isInitialCall = false, radiusKm = 2) => {
    await this.waitForLeafletController()
    // try {
    //   await this.leafletController.positionMapAtUserPosition(isInitialCall)
    //   this.setState({userPosSet: true})
    // }
    // catch (error) {
    //   if (!isInitialCall) {
    //     this.setState({
    //       showErrorAlert: true,
    //       errorAlertMessage: error.message,
    //     })
    //   }
    // }

    const setError = (errorMessage) => {
      if (!isInitialCall) {
        this.setState({
          showErrorAlert: true,
          errorAlertMessage: errorMessage,
        })
      }
    }

    const searchAndPositionForCoords = (coords) => {

      this.setState({
        showList: false,
      })
      this.searchForCoords(coords, radiusKm, true, true, true)
    }

    const onPosition = (position) => {
      if (position && position.coords && position.coords.longitude && position.coords.latitude) {
        const latlng = {lat: position.coords.latitude, lng: position.coords.longitude}
        this.setState({
          userPositionLatLng: latlng
        })
        this.leafletController.positionMapAtUserPosition()
        searchAndPositionForCoords(latlng)
      }
      else {
        setError(I18N.get('tripproxy.errors.nogps'))
      }
    }

    const onError = (error) => {
      setError(error.message)
    }

    if (window.KesiTools) {
      try {
        const position = await window.KesiTools.getGeolocation()
        onPosition(position)
      }
      catch (error) {
        onError(error)
      }

    }

    else if (window.navigator && window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(onPosition, onError, {timeout: 10000})
    }

    else {
      setError(I18N.get('tripproxy.errors.nogps'))
    }
  }

  getChangeFilterSettingsMethod () {
    return (settings) => {
      this.setState({
        filterSettings: settings,
      })
      this.updatePois()
    }
  }

  setCategoryVisible = (category, visible) => {
    const filterSettings = this.filterSettings || this.state.filterSettings
    filterSettings.visibility[category] = visible
    this.filterSettings = filterSettings
    this.setState({filterSettings})
    console.log('filterSettings', filterSettings)
    setTimeout(() => {
      this.updatePois()
      if (visible) {
        this.searchForCoords(this.state.mapCenter, [category])
      }
    })
  }

  setSelectedCountry = (countryCode) => {
    if (!this.state.selectedCountry !== countryCode) {
      this.setState({
        selectedCountry: countryCode
      })
      setTimeout(() => {
        this.updatePois()
        this.searchForCoordsAndCountries(this.state.mapCenter, [countryCode])
      })
    }
  }

  getCloseAllMarkerTooltipsAndSettingsMethod () {
    return () => {

      const state = {
        showSettings: false,
      }

      if (!this.isOpeningMarker) {
        state.currentPoi = null
      }

      this.setState(state)
    }
  }

  requestExtraData () {
    return (poi) => {
      return new Promise((resolve) => {
        try {
          this.requestPoiExtraData(poi).then(updatedPoi => {
            resolve(updatedPoi)
            poi.extraData = true   // no matter if it was successful or not, we only ask once
          }).catch(error => {
            poi.extraData = true   // no matter if it was successful or not, we only ask once
          })
        }
        catch (error) {
          poi.extraData = true   // no matter if it was successful or not, we only ask once
        }
      })
    }
  }

  getNavigateToPoiMethod () {
    return (poi) => {
      if (poi === null) {
        return
      }

      this.setState({
        currentPoi: poi,
        mapCenter: {lat: poi.lat, lng: poi.lng},
        showList: false,
        swipePageIndex: SWIPE_INDEX_MAP,
      })
      setTimeout(() => {
        this.leafletController.showPopup(poi)
      })
    }
  }

  registerLeafletController = (leafletController) => {
    this.leafletController = leafletController
    if (this.onLeafletControllerAvailable) {
      this.onLeafletControllerAvailable()
      this.onLeafletControllerAvailable = null
    }
    this.configFunctions.setCenterUserPositionOnMapFn(this.searchForUserPosition)
    this.configFunctions.setShowPoiDetailsFn(this.getShowPoiDetailMethod())
    this.configFunctions.setLeafletController(this.leafletController)
    this.forceUpdate()
  }

  updatePois = (zoomChanged = false) => {

    // unless zoom changed keep currently visible POIs, ...
    let pois = this.state.visiblePois
    if (zoomChanged) {
      pois = []
    }

    // ... as long as they match all conditions
    // pois = pois.filter(poi => poi.isInArea(this.state.visibleMapArea))
    pois = pois.filter(poi => this.availableCategories.includes(poi.category))
    const settings = this.state.filterSettings

    pois.forEach(poi => {
      poi.isVisible = settings.visibility[poi.category] || false

      // Why are we not fetching this data when we are fetching the poi itself? why call it additionally?
      // if (!poi.getHasExtraData()) {
      //   this.poiCache.requestPoiExtraData(poi, this.props.lang)
      // }
    })

    if (this.state.selectedCountry) {
      pois = pois.filter(poi => {
        // console.log('sendingCountry', poi.sendingCountry, this.state.selectedCountry, poi.sendingCountry.toLowerCase() === this.state.selectedCountry.toLowerCase())
        return poi.sendingCountry.toLowerCase() === this.state.selectedCountry.toLowerCase()
      })
    }

    const visiblePois = pois.filter(poi => poi.isVisible)
    const visiblePoiIds = visiblePois.map(poi => poi.id)

    // If there are less than MAX_NUMBER_OF_VISIBLE_POIS left on the current screen, add the best from the cached ones
    const visiblePoisInViewCount = visiblePois.filter(poi => poi.isInArea(this.state.visibleMapArea)).length
    // let poiCountToAdd = Math.max(0, MAX_NUMBER_OF_VISIBLE_POIS - visiblePoisInViewCount)
    let poiCountToAdd = this.poiCache.getPois().length - visiblePoisInViewCount

    if (poiCountToAdd > 0) {
      this.poiCache.getPois()
        .filter(poi => poi.isInArea(this.state.visibleMapArea))
        .filter(poi => {
          const settings = this.state.filterSettings
          if (this.state.selectedCountry) {
            if (poi.sendingCountry.toLowerCase() !== this.state.selectedCountry.toLowerCase()) {
              return false
            }
          }
          return settings.visibility[poi.category] || false

        })
        .sort((poi1, poi2) => {
          if (!poi2.ranking) {
            return -1
          }

          if (!poi1.ranking) {
            return 1
          }

          return poi1.ranking <= poi2.ranking
        })
        .every(poi => {
          if (visiblePoiIds.indexOf(poi.id) >= 0) {
            return true  // same as continue in old for loop
          }
          pois.push(poi)
          visiblePoiIds.push(poi.id)
          poiCountToAdd -= 1

          return poiCountToAdd > 0   // false == break in old for loop; true == continue in old for loop
        })
    }

    this.setState({
      visiblePois: pois,
    })
  }

  updatePoisDeferred = () => {
    clearTimeout(this.updatePoisDeferredTimeout)

    this.updatePoisDeferredTimeout = setTimeout(() => {
      this.updatePois()
    }, 500)
  }

  setIsSearching = (isSearching) => {
    this.setState({
      showIsSearchingOverlay: isSearching
    })
  }

  async waitForLeafletController () {
    if (this.leafletController) {
      return Promise.resolve()
    }
    return new Promise((resolve, reject) => {
      this.onLeafletControllerAvailable = resolve
    })
  }

  renderToolbar () {
    // <AppBar
    //   showMenuIconButton={false}
    //   title={this.renderSearchField()}
    // />
    const config = this.config.getConfig()

    if (config.type && (config.type === NO_POIS_NEEDED || config.type === NO_TOOLBAR)) {
      return null
    }

    let icon
    if (this.state.showList) {
      icon = (
        <IconButton className={s.mapButton} onClick={this.getSetShowPoiListMethod(false)}>
          <MapIcon nativeColor="#BEB400"/>
        </IconButton>
      )
    }
    else {
      icon = (
        <IconButton className={s.listButton} onClick={this.getSetShowPoiListMethod(true)}>
          <ListIcon nativeColor="#BEB400"/>
        </IconButton>
      )
    }

    const searchIcon = this.state.showIsSearchingOverlay
      ? <CircularProgress
        size={24}
        style={{padding: 10}}
        thickness={2.5}
      />
      : <img
        className={s.magnifierIcon}
        src={require('./img/search.svg')}
        alt="search icon"
      />

    const className = `${s.toolbar} toolbar`

    return (

      <Toolbar className={className} style={{transform: 'translate3d(0, 0, 0)', width: 'calc(100% - 52px)'}}>
        {/*<ToolbarGroup firstChild className={s.toolbarGroup}>*/}
        {searchIcon}
        <span className={s.searchField}>
            <SearchComponent
              searchForCoords={this.getPositionAtAndSearchForCoordsMethod()}
              userPosition={this.state.userPositionLatLng}
              mapPosition={this.state.mapCenter}
              onError={this.getShowErrorMethod()}
              countryCodes={this.props.countryCodes}
              isSearching={this.state.showIsSearchingOverlay}
            />
          </span>
        {icon}
        {/*</ToolbarGroup>*/}
      </Toolbar>
    )
  }

  renderDetailView () {
    if (/*this.state.swipePageIndex === SWIPE_INDEX_DETAIL && */this.state.currentPoi) {
      return (
        <div>
          <PoiDetailComponent
            poi={this.state.currentPoi}
            // goBack={this.getShowMapMethod()}
            // forceUpdate={() => this.forceUpdate()}
            // userPosition={this.state.userPositionLatLng}
            // onNavigateToPoi={this.getNavigateToPoiMethod()}
            mapHeight={this.state.mapHeight}
            functions={this.configFunctions}
            config={this.config.getCategoriesConfig()}
            referencedConfigs={this.props.referencedConfigs}
          />
        </div>
      )
    }

    // we can't return null here because the swipeable views don't like it
    return (
      <div/>
    )
  }

  renderErrorAlert () {

    const closeAlert = () => {
      this.setState({
        showErrorAlert: false,
      })
    }

    return (
      <Dialog
        open={this.state.showErrorAlert}
        onClose={closeAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{this.state.errorAlertMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeAlert}
            variant={'flat'}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

    )
  }

  renderSettings () {
    return (
      <SettingsComponent
        config={this.config.getSettingsConfig()}
        filterSettings={this.state.filterSettings}
        functions={this.configFunctions}
        settingStates={this.state.settingState}
        setCategoryVisible={this.setCategoryVisible}
        showOverlay={this.state.showOverlay}
        showSettingsWithId={this.state.showSettingsWithId}
        setSelectedCountry={this.setSelectedCountry}
        mapIsVisible={this.state.showMap}
        listIsVisible={this.state.showList}
      />
    )
  }

  renderListView () {
    if (this.state.showList /*&& this.state.swipePageIndex === SWIPE_INDEX_MAP*/) {
      return (
        <div
          style={style.list}
        >
          <PoiListComponent
            className={s.list}
            pois={this.state.visiblePois.slice(0, 20)}
            //goBack={this.getShowMapMethod()}
            //showDetails={this.getShowPoiDetailMethod()}
            userPosition={this.state.userPositionLatLng}
            mapPosition={this.state.mapCenter}
            //onNavigateToPoi={this.getNavigateToPoiMethod()}
            height={this.state.mapHeight}
            config={this.config.getCategoriesConfig()}
            functions={this.configFunctions}
            referencedConfigs={this.props.referencedConfigs}
          />
        </div>
      )
    }
    return null
  }

  renderMapComponent () {
    // TODO: find out why nothing is displayed if the map is not rendered.
    // workaround (used here) is to set visibility to hidden if map should not be displayed
    const mapStyle = {
      height: this.state.mapHeight
    }

    if (this.state.showList) {
      mapStyle.visibility = 'hidden'
    }

    if (!this.state.mapHeight) {
      return null
    }

    return (
      <div
        style={mapStyle}
      >
        <Leaflet
          provider={PROVIDERS.HERE}
          appId="wzkqKPQQ8gEeWP5Kt3PW"
          appCode="pNtuh89rVKq9VZCA9OOofA"

          controllerInterfaceRegistration={this.registerLeafletController}
          showUserPosition={true}

          onBoundsChanged={this.getOnMapBoundsChangedMethod()}
          onDrag={this.getOnMapDragMethod()}
          pois={this.state.visiblePois}

          useCIT
          defaultUserPosition={this.state.userPositionLatLng}
          locationMarkerPosition={this.state.locationMarkerPosition}
          onBubbleTapped={this.getShowPoiDetailMethod()}
          requestExtraData={this.requestExtraData()}
          lang={this.props.lang}
          renderPoiBubbleComponent={this.renderPoiBubbleComponent}
          config={this.config.getConfig()}
          functions={this.configFunctions}
          dataSource={this.leafletDataSource}
        />
      </div>
    )
  }

  renderPoiBubbleComponent = (poi) => {
    return (
      <PoiBubbleComponent
        poi={poi}
        config={this.config.getCategoriesConfig()}
        referencedConfigs={this.props.referencedConfigs}
        functions={this.configFunctions}
      />
    )
  }

  showSettingsWithId = (id) => {
    // console.log('showSettingsWithId', id)
    if (id !== this.state.showSettingsWithId) {
      this.setState({showSettingsWithId: id})
    }
  }

  hideOverlay = () => {
    this.setState({showOverlay: false, overlayShown: true})
  }

  renderOverlays = () => {
    if (this.state.showOverlay && !this.state.overlayShown && this.config.getOverlayConfig() !== null/* && (this.state.poisSet)*/) {
      return (
        <Walkthrough
          steps={this.config.getOverlayConfig().steps || []}
          onExit={this.hideOverlay}
          showSettingsWithId={this.showSettingsWithId}
          config={this.config.getOverlayConfig()}
          filterSettings={this.state.filterSettings}
          functions={this.configFunctions}
        />
      )
    }
    return null
  }

  renderMapOverlay () {
    return this.leafletDataSourceOverlay
  }

  renderMapView () {
    return (
      <div style={{overflow: 'hidden', width: '100vw'}}>
        {this.renderToolbar()}
        {this.renderErrorAlert()}
        {this.renderMapComponent()}
        {this.renderMapOverlay()}
        {this.renderSettings()}
        {this.renderListView()}
        {this.renderOverlays()}
      </div>
    )
  }

  //
  // renderSettings () {
  //   if (this.state.showSettings) {
  //     return (
  //       <div
  //         className={s.settings}
  //       >
  //         <FilterSettingsComponent
  //           settings={this.state.filterSettings}
  //           onChangeSettings={this.getChangeFilterSettingsMethod()}
  //           closeSettings={this.getSetShowSettingsMethod(false)}
  //         />
  //       </div>
  //     )
  //   }
  //   return null
  // }

  render () {
    // return (
    //   <div>
    //     {this.renderMapView()}
    //     {this.renderErrorAlert()}
    //   </div>
    // )

    return (
      <div>
        <div style={{maxHeight: 0, maxWidth: 0, overflow: 'hidden'}}>
          <input
            style={{width: 0, height: 0, opacity: 0, position: 'absolute', top: 0, left: 0}}
            type="text"
            id={UNFOCUS_ELEMENT_ID}
          />
        </div>

        <SwipeableViews
          className={s.swipeableView}
          disabled
          index={this.state.swipePageIndex}
          style={{backgroundColor: '#e6e6e6'}}
        >
          {this.renderMapView()}
          {this.renderDetailView()}
        </SwipeableViews>
        {this.renderErrorAlert()}
      </div>
    )
  }

}

TripAdvisor.propTypes = {
  mapCenter: PropTypes.object,
  visiblePois: PropTypes.array,
  showPoweredByTripAdvisor: PropTypes.bool,
  lang: PropTypes.string,
  i18n: PropTypes.object.isRequired,
  config: PropTypes.object,
  requestedConfigName: PropTypes.string,
  referencedConfigs: PropTypes.object,
  countryCodes: PropTypes.object.isRequired
}

TripAdvisor.defaultProps = {
  mapCenter: CENTER_EUROPE,
  showPoweredByTripAdvisor: true,
  config: null,
}

export default TripAdvisor



// WEBPACK FOOTER //
// ./src/components/TripAdvisor/TripAdvisor.js